import { RouteObject } from 'react-router-dom';

import { PATH } from '~/constants/route-path';
import ContactUs from '~/pages/ContactUs';
import DataDeletion from '~/pages/DataDeletion';
import FAQ from '~/pages/FAQ';
import HomePage from '~/pages/HomePage/HomePage';
import PlansAndPricesPage from '~/pages/PlansAndPricesPage/PlansAndPricesPage';
import QrsOn from '~/pages/QrsOn/QrsOn';
import QrsOnDetail from '~/pages/QrsOn/QrsOnDetail/QrsOnDetail';
import Privacy from '~/pages/UnauthQr/components/Privacy';
import GuestRoute from '~/routes/GuestRoute';

const UNAUTH_QR_ROUTES: RouteObject[] = [
  {
    path: PATH.UNAUTH.QRS_ON,
    element: (
      <GuestRoute>
        <QrsOn />
      </GuestRoute>
    ),
  },
  {
    path: PATH.UNAUTH.QRS_ON_DETAIL('menu'),
    element: (
      <GuestRoute>
        <QrsOnDetail />
      </GuestRoute>
    ),
  },
  {
    path: PATH.UNAUTH.MAIN,
    element: (
      <GuestRoute>
        <HomePage />
      </GuestRoute>
    ),
  },
  {
    path: PATH.UNAUTH.PRICES_AND_PLANS,
    element: (
      <GuestRoute>
        <PlansAndPricesPage />
      </GuestRoute>
    ),
  },
  {
    path: PATH.UNAUTH.FAQ,
    element: (
      <GuestRoute>
        <FAQ />
      </GuestRoute>
    ),
  },
  {
    path: PATH.UNAUTH.PRIVACY_POLICY,
    element: (
      <GuestRoute>
        <Privacy />
      </GuestRoute>
    ),
  },
  {
    path: PATH.UNAUTH.DATA_DELETION,
    element: (
      <GuestRoute>
        <DataDeletion />
      </GuestRoute>
    ),
  },
  {
    path: '/contact-us',
    element: (
      <GuestRoute>
        <ContactUs />
      </GuestRoute>
    ),
  },
];

export { UNAUTH_QR_ROUTES };
